
/*
NO SE USA MAS ESE CONTENT PARA DEFINIR LAS SECTIONS
DEPENDE DE LOS PERMISOS DEL USUARIO,
ESO SE HACE EXTERNAMENTE A LA APP
*/
/* eslint-disable */
import type { UiNavigationItem } from 'app/shared/components/others/navigation/navigation.types';

/* Principal Navigation */
export const defaultNavigation: UiNavigationItem[] = [
    {
        id: 'my-org',
        title: 'Inicio',
        type: 'basic',
        icon: 'hgi-home-03',
        link: '/admin/home',
        confirmNavigation: true,
    },
    {
        id: 'teams',
        title: 'Equipos',
        type: 'basic',
        icon: 'hgi-user-group',
        link: '/admin/crews',
        confirmNavigation: true
    },
    {
        id: 'kbs',
        title: 'Bases de conocimiento',
        type: 'basic',
        icon: 'hgi-book-02',
        link: '/admin/kbs',
        confirmNavigation: true
    },
    {
        id: 'supervisor',
        title: 'Supervisión de equipos',
        type: 'basic',
        icon: 'hgi-presentation-line-chart-02',
        link: '/admin/supervisor',
        confirmNavigation: true,
    },
    {
        id: 'history',
        title: 'Historial de conversaciones',
        type: 'basic',
        icon: 'hgi-clock-02',
        link: '/admin/history',
        confirmNavigation: true
    },
    {
        id: 'reports',
        title: 'Reportes',
        type : 'basic',
        icon : 'hgi-chart-average',
        link : '/admin/reports',
        confirmNavigation: true
    },
    {
        id   : 'custom-reports',
        title: 'Reportería avanzada',
        type : 'basic',
        icon : 'hgi-chart-line-data-02',
        link : '/admin/custom-reports',
        confirmNavigation: true
    },
    {
        id   : 'channels',
        title: 'Canales',
        type : 'basic',
        icon : 'hgi-customize',
        link : '/admin/channels',
        confirmNavigation: true
    },
    {
        type: 'footer-divider',
    },
    {
        id: 'examples',
        title: 'Component Catalog',
        type: 'basic',
        icon: 'hgi-paint-board',
        link: '/admin/examples',
    },
    {
        id: 'trash',
        title: 'Papelera',
        type: 'footer',
        icon: 'hgi-delete-02',
        link: '/admin/recycle-bin',
        confirmNavigation: true
    },
];

export const compactNavigation: UiNavigationItem[] = [
    {
        id: 'home',
        title: 'home',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/admin/home'
    },
    {
        id: 'crews',
        title: 'Crews',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/crews'
    }
];
export const futuristicNavigation: UiNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/admin/home'
    },
    {
        id: 'crews',
        title: 'Crews',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/crews'
    }
];
export const horizontalNavigation: UiNavigationItem[] = [
    {
        id: 'home',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/admin/home'
    },
    {
        id: 'crews',
        title: 'Crews',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/crews'
    }
];
